import { i18n } from "services/i18nService";

import { OBJECT_TYPES } from "appConstants";

export const SETTINGS = [
  {
    apiName: "salesReceiptNumber",
    component: "FrmTransactionNumber",
    transactionType: OBJECT_TYPES.SALES_RECEIPT.fullString,
    hasInputLabel: true,
  },
  {
    apiName: "replyEmailSalesReceipt",
    component: "FrmEmail",
    maxLength: 255,
  },
  {
    apiName: "salesReceiptEmail",
    component: "FrmResizeTextField",
    explanationOverride: (
      <>
        {i18n("settings.sales.salesReceipts.salesReceiptEmail.explanation.1")}
        <p>
          {i18n("settings.sales.salesReceipts.salesReceiptEmail.explanation.2")}
        </p>
        <div>
          {i18n("settings.sales.salesReceipts.salesReceiptEmail.explanation.3")}
        </div>
        <div>
          {i18n("settings.sales.salesReceipts.salesReceiptEmail.explanation.4")}
        </div>
        <div>
          {i18n("settings.sales.salesReceipts.salesReceiptEmail.explanation.5")}
        </div>
      </>
    ),
  },
  { apiName: "salesReceiptFooter", component: "FrmResizeTextField" },
  {
    apiName: "defaultCCSalesReceipt",
    component: "FrmEmail",
    maxLength: 255,
  },
  {
    apiName: "includeSalesReceiptsInAvailableForSale",
    component: "FrmCheckbox",
  },
];
